import { render, staticRenderFns } from "./ParesAlreadyInDiagnose.vue?vue&type=template&id=283a25e4&scoped=true&"
import script from "./ParesAlreadyInDiagnose.vue?vue&type=script&lang=js&"
export * from "./ParesAlreadyInDiagnose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283a25e4",
  null
  
)

export default component.exports